import { useParams } from "react-router"

import ProjectViewChecklistsListSection from "./ProjectViewChecklistsListSection/ProjectViewChecklistsListSection.tsx"

const ProjectViewChecklistsSection = () => {
  const projectId = useParams()?.id as string

  return <ProjectViewChecklistsListSection projectId={projectId} />
}

export default ProjectViewChecklistsSection
